module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Regist image","file":{"label":"Image file","error":"The image cannot be read"},"comment":{"label":"Comment"},"submit":"Regist"},"ja":{"title":"画像登録","file":{"label":"画像ファイル","error":"画像が読み取れません"},"comment":{"label":"コメントを入力する"},"submit":"登録する"}}')
  delete Component.options._Ctor
}
